import { ScreenLoading } from '@/components/loading';
import { ScreenError } from '@/components/screen-error';
import { ScreenCosts } from '@/components/screens/costs-screen';
import { useRailwayCosts } from '@/hooks/use-railway-costs';
import { useScreenProps } from '@/store/theme';

export function CostsPage() {
  const sp = useScreenProps();
  const { data, isLoading, isError, error, refetch, isFetching } = useRailwayCosts();

  // Erro ANTES do loading: sem isso a tela fica em spinner infinito quando a
  // query falha (isLoading volta a false, mas `data` segue undefined). Aqui o
  // ScreenError é o certo — nesta tela o custo NÃO é um extra que degrada para
  // "—", é o assunto. Ele já traz o botão de tentar novamente.
  //
  // `semToken` e `precoDiscoConfirmado: false` NÃO passam por aqui: são
  // respostas 200 com aviso, tratadas dentro de ScreenCosts.
  if (isError && !data) {
    return (
      <ScreenError
        error={error}
        onRetry={() => void refetch()}
        retrying={isFetching}
        active="costs"
        role="admin"
        title="Gastos"
        subtitle="Estimativa de custo dos projetos no Railway"
      />
    );
  }
  if (isLoading || !data) return <ScreenLoading dark={sp.dark} />;

  return (
    <div style={{ height: 'var(--app-vh)', overflow: 'hidden' }}>
      <ScreenCosts
        {...sp}
        costs={data}
        atualizando={isFetching}
        onAtualizar={() => void refetch()}
      />
    </div>
  );
}
